module.exports = __webpack_public_path__ + "static/025-0666cb8981d55419e4bcb55fc52f4d1d.jpg";